import Typography, { TypographyVariant } from '@ben/orion/typography';
import { Group, Stack, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { domainLabel } from './domains';
import { StatusTag } from './status';
import type { WorkspaceStatus } from './status';
import { useGroupDetail } from './use-group-detail';

export const PendingChanges = () => {
  const { awaiting } = useGroupDetail();
  if (awaiting.length === 0) return null;

  return (
    <section>
      <Typography variant={TypographyVariant.h2}>
        Changes awaiting a decision
      </Typography>
      <Stack gap="sm">
        {awaiting.map((change) => (
          <ChangeCard key={change.id} to={`/requirements/changes/${change.id}`}>
            <Group justify="space-between">
              <Typography variant={TypographyVariant.bodyMd1}>
                {domainLabel(change.domain)}
              </Typography>
              <StatusTag status={change.status as WorkspaceStatus} />
            </Group>
            <Text size="sm" c="dimmed">
              {change.summary}
            </Text>
          </ChangeCard>
        ))}
      </Stack>
    </section>
  );
};

const ChangeCard = styled(Link)`
  ${({ theme }) => css`
    display: grid;
    gap: ${theme.spacing(1)};
    background: ${theme.palette.neutral['00']};
    border: 1px solid ${theme.palette.neutral[40]};
    border-radius: ${theme.borderRadius.md};
    padding: ${theme.spacing(2)} ${theme.spacing(3)};
    color: inherit;
    text-decoration: none;

    &:hover {
      border-color: ${theme.palette.primary.main};
    }

    &:focus-visible {
      outline: 2px solid ${theme.palette.primary.main};
      outline-offset: 2px;
    }
  `}
`;
